import React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import Title from "./Title";
import Terms from "./Terms";

const TermsAndConditions = () => {
	return (
		<>
			<Header />
			<Title />
			<Terms />
			<Footer />
		</>
	);
};
export default TermsAndConditions;
